// Copyright (c) 2016 Deere & Company

import * as sharedClaimTypesActionCreator from '../../../shared/action-creators/get-claim-types';
import actions from '../../action-list';

export const readClaimTypes = () => sharedClaimTypesActionCreator.readClaimTypes(actions.UPDATE_CLAIM_PIP_CLAIM_TYPES);



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/get-claim-types.js